/**
 * 全局define函数
 *
 * @author yusangeng@outlook.com
 */
import { CacheStatus } from '../cache/cache';
import { getInstance } from '../singleton';
var win = window;
var define = win.define;
var keys = Object.keys;
var hasOtherAMDLoader = false;
if (typeof define !== 'undefined' && !define.runtime_import) {
    console.warn("runtime-import should NOT coexist with requiesjs or seajs or any other AMD/CMD loader.");
    hasOtherAMDLoader = true;
}
var pendingItemMap = getInstance('pendingItemMap', function () { return ({}); });
// 模拟AMD, 注意只能用来加载UMD格式的js
var umdDefine = function define() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var factory = args.pop();
    var currentScript = document.currentScript;
    if (!currentScript) {
        throw new Error("currentScript is null.");
    }
    var src = currentScript.src;
    var item = pendingItemMap[src];
    if (!item) {
        throw new Error("Can NOT find item, src=".concat(src));
    }
    pendingItemMap[src] = null;
    try {
        var externals_1 = args[0] || [];
        var name_1 = null;
        if (typeof externals_1 === 'string') {
            name_1 = externals_1;
            externals_1 = args[1] || [];
        }
        var exportThing = (item.exportThing = (function () {
            var useCurrentExports = false;
            var currentExports = {};
            var ret = factory.apply(void 0, externals_1.map(function (el) {
                // exports会被直接用于写导出对象，如果传入undefined会导致报错
                if (el === 'exports') {
                    useCurrentExports = true;
                    return currentExports;
                }
                return win[el];
            }));
            if (!ret && useCurrentExports) {
                ret = currentExports;
            }
            return ret;
        })());
        if (name_1) {
            win[name_1] = exportThing;
        }
        if (exportThing && keys(exportThing).length === 1 && exportThing.default) {
            item.exportThing = exportThing.default;
            item.exportThing.default = exportThing.default;
        }
    }
    catch (err) {
        item.status = CacheStatus.ERROR;
        if (err instanceof Error) {
            item.error = err;
        }
        item.reject(err);
    }
};
var amdFlagCheater = function () {
    var currentScript = document.currentScript;
    if (currentScript) {
        var src = currentScript.src;
        var item = pendingItemMap[src];
        if (item) {
            return true;
        }
    }
    return false;
};
['amd', 'cmd'].forEach(function (el) {
    Object.defineProperty(umdDefine, el, {
        get: amdFlagCheater
    });
});
// private flag
umdDefine.runtime_import = true;
export default function addItem(src, item) {
    if (hasOtherAMDLoader) {
        throw new Error("runtime-import UMD mode uses window.define, you should NOT have your own window.define.");
    }
    if (!win.define) {
        win.define = umdDefine;
    }
    pendingItemMap[src] = item;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5lLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2luc3RhbGxlci9kZWZpbmUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7R0FJRztBQUVILE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSxnQkFBZ0IsQ0FBQTtBQUU1QyxPQUFPLEVBQUUsV0FBVyxFQUFFLE1BQU0sY0FBYyxDQUFBO0FBRTFDLElBQU0sR0FBRyxHQUFHLE1BQWEsQ0FBQTtBQUNqQixJQUFBLE1BQU0sR0FBSyxHQUFHLE9BQVIsQ0FBUTtBQUNkLElBQUEsSUFBSSxHQUFLLE1BQU0sS0FBWCxDQUFXO0FBRXZCLElBQUksaUJBQWlCLEdBQUcsS0FBSyxDQUFBO0FBRTdCLElBQUksT0FBTyxNQUFNLEtBQUssV0FBVyxJQUFJLENBQUMsTUFBTSxDQUFDLGNBQWMsRUFBRTtJQUMzRCxPQUFPLENBQUMsSUFBSSxDQUFDLHdGQUF3RixDQUFDLENBQUE7SUFDdEcsaUJBQWlCLEdBQUcsSUFBSSxDQUFBO0NBQ3pCO0FBRUQsSUFBTSxjQUFjLEdBQUcsV0FBVyxDQUFxQyxnQkFBZ0IsRUFBRSxjQUFNLE9BQUEsQ0FBQyxFQUFFLENBQUMsRUFBSixDQUFJLENBQUMsQ0FBQTtBQVNwRywwQkFBMEI7QUFDMUIsSUFBTSxTQUFTLEdBQWUsU0FBUyxNQUFNO0lBQUMsY0FBbUI7U0FBbkIsVUFBbUIsRUFBbkIscUJBQW1CLEVBQW5CLElBQW1CO1FBQW5CLHlCQUFtQjs7SUFDL0QsSUFBTSxPQUFPLEdBQUcsSUFBSSxDQUFDLEdBQUcsRUFBRSxDQUFBO0lBQ2xCLElBQUEsYUFBYSxHQUFLLFFBQVEsY0FBYixDQUFhO0lBRWxDLElBQUksQ0FBQyxhQUFhLEVBQUU7UUFDbEIsTUFBTSxJQUFJLEtBQUssQ0FBQyx3QkFBd0IsQ0FBQyxDQUFBO0tBQzFDO0lBRUssSUFBQSxHQUFHLEdBQUssYUFBa0MsSUFBdkMsQ0FBdUM7SUFDaEQsSUFBSSxJQUFJLEdBQUcsY0FBYyxDQUFDLEdBQUcsQ0FBQyxDQUFBO0lBRTlCLElBQUksQ0FBQyxJQUFJLEVBQUU7UUFDVCxNQUFNLElBQUksS0FBSyxDQUFDLGlDQUEwQixHQUFHLENBQUUsQ0FBQyxDQUFBO0tBQ2pEO0lBRUQsY0FBYyxDQUFDLEdBQUcsQ0FBQyxHQUFHLElBQUksQ0FBQTtJQUUxQixJQUFJO1FBQ0YsSUFBSSxXQUFTLEdBQUcsSUFBSSxDQUFDLENBQUMsQ0FBQyxJQUFJLEVBQUUsQ0FBQTtRQUM3QixJQUFJLE1BQUksR0FBRyxJQUFJLENBQUE7UUFFZixJQUFJLE9BQU8sV0FBUyxLQUFLLFFBQVEsRUFBRTtZQUNqQyxNQUFJLEdBQUcsV0FBUyxDQUFBO1lBQ2hCLFdBQVMsR0FBRyxJQUFJLENBQUMsQ0FBQyxDQUFDLElBQUksRUFBRSxDQUFBO1NBQzFCO1FBRUQsSUFBTSxXQUFXLEdBQUcsQ0FBQyxJQUFJLENBQUMsV0FBVyxHQUFHLENBQUM7WUFDdkMsSUFBSSxpQkFBaUIsR0FBRyxLQUFLLENBQUE7WUFDN0IsSUFBTSxjQUFjLEdBQUcsRUFBRSxDQUFBO1lBRXpCLElBQUksR0FBRyxHQUFHLE9BQU8sZUFDWixXQUFTLENBQUMsR0FBRyxDQUFDLFVBQUMsRUFBVTtnQkFDMUIsd0NBQXdDO2dCQUN4QyxJQUFJLEVBQUUsS0FBSyxTQUFTLEVBQUU7b0JBQ3BCLGlCQUFpQixHQUFHLElBQUksQ0FBQTtvQkFDeEIsT0FBTyxjQUFjLENBQUE7aUJBQ3RCO2dCQUVELE9BQU8sR0FBRyxDQUFDLEVBQUUsQ0FBQyxDQUFBO1lBQ2hCLENBQUMsQ0FBQyxDQUNILENBQUE7WUFFRCxJQUFJLENBQUMsR0FBRyxJQUFJLGlCQUFpQixFQUFFO2dCQUM3QixHQUFHLEdBQUcsY0FBYyxDQUFBO2FBQ3JCO1lBRUQsT0FBTyxHQUFHLENBQUE7UUFDWixDQUFDLENBQUMsRUFBRSxDQUFDLENBQUE7UUFFTCxJQUFJLE1BQUksRUFBRTtZQUNSLEdBQUcsQ0FBQyxNQUFJLENBQUMsR0FBRyxXQUFXLENBQUE7U0FDeEI7UUFFRCxJQUFJLFdBQVcsSUFBSSxJQUFJLENBQUMsV0FBVyxDQUFDLENBQUMsTUFBTSxLQUFLLENBQUMsSUFBSSxXQUFXLENBQUMsT0FBTyxFQUFFO1lBQ3hFLElBQUksQ0FBQyxXQUFXLEdBQUcsV0FBVyxDQUFDLE9BQU8sQ0FBQTtZQUN0QyxJQUFJLENBQUMsV0FBVyxDQUFDLE9BQU8sR0FBRyxXQUFXLENBQUMsT0FBTyxDQUFBO1NBQy9DO0tBQ0Y7SUFBQyxPQUFPLEdBQUcsRUFBRTtRQUNaLElBQUksQ0FBQyxNQUFNLEdBQUcsV0FBVyxDQUFDLEtBQUssQ0FBQTtRQUMvQixJQUFJLEdBQUcsWUFBWSxLQUFLLEVBQUU7WUFDeEIsSUFBSSxDQUFDLEtBQUssR0FBRyxHQUFHLENBQUE7U0FDakI7UUFDRCxJQUFJLENBQUMsTUFBTyxDQUFDLEdBQUcsQ0FBQyxDQUFBO0tBQ2xCO0FBQ0gsQ0FBZSxDQUFBO0FBRWYsSUFBTSxjQUFjLEdBQUc7SUFDYixJQUFBLGFBQWEsR0FBSyxRQUFRLGNBQWIsQ0FBYTtJQUVsQyxJQUFJLGFBQWEsRUFBRTtRQUNYLElBQUEsR0FBRyxHQUFLLGFBQWtDLElBQXZDLENBQXVDO1FBQ2hELElBQUksSUFBSSxHQUFHLGNBQWMsQ0FBQyxHQUFHLENBQUMsQ0FBQTtRQUU5QixJQUFJLElBQUksRUFBRTtZQUNSLE9BQU8sSUFBSSxDQUFBO1NBQ1o7S0FDRjtJQUVELE9BQU8sS0FBSyxDQUFBO0FBQ2QsQ0FBQyxDQUVBO0FBQUEsQ0FBQyxLQUFLLEVBQUUsS0FBSyxDQUFDLENBQUMsT0FBTyxDQUFDLFVBQUEsRUFBRTtJQUN4QixNQUFNLENBQUMsY0FBYyxDQUFDLFNBQVMsRUFBRSxFQUFFLEVBQUU7UUFDbkMsR0FBRyxFQUFFLGNBQWM7S0FDcEIsQ0FBQyxDQUFBO0FBQ0osQ0FBQyxDQUFDLENBQUE7QUFFRixlQUFlO0FBQ2YsU0FBUyxDQUFDLGNBQWMsR0FBRyxJQUFJLENBQUE7QUFFL0IsTUFBTSxDQUFDLE9BQU8sVUFBVSxPQUFPLENBQUMsR0FBVyxFQUFFLElBQWlCO0lBQzVELElBQUksaUJBQWlCLEVBQUU7UUFDckIsTUFBTSxJQUFJLEtBQUssQ0FBQyx5RkFBeUYsQ0FBQyxDQUFBO0tBQzNHO0lBRUQsSUFBSSxDQUFDLEdBQUcsQ0FBQyxNQUFNLEVBQUU7UUFDZixHQUFHLENBQUMsTUFBTSxHQUFHLFNBQVMsQ0FBQTtLQUN2QjtJQUVELGNBQWMsQ0FBQyxHQUFHLENBQUMsR0FBRyxJQUFJLENBQUE7QUFDNUIsQ0FBQyJ9